import React from "react";
import { useTour } from "../../Context/TourContext";
import "./TourOverlay.scss";

interface TourOverlayProps {
  targetId: string;
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

const TourOverlay: React.FC<TourOverlayProps> = ({
  targetId,
  children,
  className = "",
  style = {},
}) => {
  const { state } = useTour();
  
  const shouldDisable = (state.tourActive && state.run);

  return (
    <div
      id={targetId}
      className={`${className} ${shouldDisable ? 'tour-disabled' : ''}`}
      style={style}
    >
      {children}
    </div>
  );
};

export default TourOverlay;
